export var defaultAssemblyPageAi = {
    isShowAiSelectContainer: false,
    isShowLowerVersionPopup: false,
    isShowDeviceNotConnectPopUp: false,
    aiItems: {
        ai_motion: false,
        ai_color_recognition: false,
        ai_color_tracking: false,
        ai_face_detection: false,
        ai_face_recognition: false,
        ai_face_tracking: false,
        ai_mic: false,
        ai_lidar: false,
        ai_LED: false,
        ai_audio: false,
        ai_proximity: false,
        ai_light: false,
    },

    aiAudioList: ['Select Ai Audio'],
    aiFaceList: [{ label: 'Select', id: '0' }],
    aiSpeechList: [
        {
            label: 'Select',
            id: '0',
        },
    ],
    aiColorList: [
        {
            label: 'Select',
            id: '0',
        },
        {
            label: 'Red',
            id: '1',
        },
        {
            label: 'Green',
            id: '2',
        },
        {
            label: 'Blue',
            id: '3',
        },
    ],
}
// export var defaultAiTrainList = {
//     speechTranList: [], //{ value: '' }
//     colorTranList: [],
//     faceTranList: [],
// }
export var aiItemsData = {
    ai_motion: {
        title: 'AI Motion',
        title2: 'AI motion detected',
        reduxCheck: 'ai_motion',
        type: 'input',
        min: 0,
        max: 1,
    },
    ai_color_recognition: {
        title: 'AI Color Recognition',
        title2: 'AI color recognised',
        reduxCheck: 'ai_color_recognition',
        type: 'input',
        // min:0,
        // ma:1500,
    },
    ai_color_tracking_X: {
        title: 'AI Track Color Detection X',
        title2: 'AI Color colorName position -> X',
        reduxCheck: 'ai_color_tracking',
        listKey: 'colorTranList',
        type: 'input',
        min: 0,
        max: 240,
    },
    ai_color_tracking_Y: {
        title: 'AI Track Color Detection Y',
        title2: 'AI Color colorName position -> Y',
        reduxCheck: 'ai_color_tracking',
        listKey: 'colorTranList',
        type: 'input',
        min: 0,
        max: 240,
    },
    ai_face_detection: {
        title: 'AI Face Detection',
        title2: 'AI Face detecting',
        reduxCheck: 'ai_face_detection',
        type: 'input',
        min: 0,
        max: 1,
    },
    ai_face_recognition: {
        title: 'AI Face Recognition',
        title2: 'AI Face recognised',
        reduxCheck: 'ai_face_recognition',
        type: 'input',
        // min:0,
        // ma:1500,
    },
    ai_face_tracking_X: {
        title: 'AI Track Face Detection X',
        title2: 'AI - Face Postion -> X',
        reduxCheck: 'ai_face_tracking',
        listKey: 'faceTranList',
        type: 'input',
        min: 0,
        max: 240,
    },
    ai_face_tracking_Y: {
        title: 'AI Track Face Detection Y',
        title2: 'AI - Face Postion -> Y',
        reduxCheck: 'ai_face_tracking',
        listKey: 'faceTranList',
        type: 'input',
        min: 0,
        max: 240,
    },
    ai_mic: {
        title: 'AI Mic',
        title2: 'AI speech recognised',
        reduxCheck: 'ai_mic',
        type: 'input',
        // min:0,
        // ma:1500,
    },
    ai_lidar: {
        title: 'AI Lidar',
        title2: 'AI Lidar',
        reduxCheck: 'ai_lidar',
        type: 'input',
        min: 0,
        max: 1500,
    },
    ai_LED: {
        title: 'AI LED',
        title2: 'AI LED',
        reduxCheck: 'ai_LED',
        type: 'output',
        min: 0,
        max: 100,
    },
    ai_audio: {
        title: 'AI Audio',
        title2: 'AI Audio',
        reduxCheck: 'ai_audio',
        type: 'output',
        // min: 0,
        // max: 100,
    },

    ai_proximity: {
        title: 'AI Proximity',
        title2: 'AI Proximity',
        reduxCheck: 'ai_proximity',
        type: 'input',
        min: 0,
        max: 6000,
    },
    ai_light: {
        title: 'AI Light',
        title2: 'AI Light',
        reduxCheck: 'ai_light',
        type: 'input',
        min: 0,
        max: 65000,
    },
}

//PA Bytes send to the board for AI
export const paBytesAi = {
    ai_mic: 'S'.codePointAt(0),
    ai_lidar: 'L'.codePointAt(0),
    ai_motion: 'M'.codePointAt(0),
    ai_face_detection: 'F'.codePointAt(0),
    ai_color_recognition: 'C'.codePointAt(0),
    ai_face_recognition: 'R'.codePointAt(0),
    ai_face_tracking_X: 0x0f,
    ai_face_tracking_Y: 0x0f,
    ai_color_tracking_X: 0x0c,
    ai_color_tracking_Y: 0x0c,

    ai_proximity: 'P'.codePointAt(0),
    ai_light: 'L'.codePointAt(0),

    // ai_color_tracking_X_red: 0x1c,
    // ai_color_tracking_Y_red: 0x1c,
    // ai_color_tracking_X_green: 0x2c,
    // ai_color_tracking_Y_green: 0x2c,
    // ai_color_tracking_X_blue: 0x3c,
    // ai_color_tracking_Y_blue: 0x3c,
}

export const getPaBytesAi = (aiComponents, sendBytes, arrIndex) => {
    if (!arrIndex) {
        return
    }

    if (aiComponents.includes('ai_face_tracking')) {
        const match = aiComponents.match(/(\d+)$/)
        let id = match ? parseInt(match[1], 10) : 0

        sendBytes[arrIndex + 1] = id
        sendBytes[arrIndex] = paBytesAi['ai_face_tracking_X']
    } else if (aiComponents.includes('ai_color_tracking')) {
        let idString = aiComponents.split('_').pop()
        let id = { red: 1, green: 2, blue: 3 }[idString] || 0

        sendBytes[arrIndex + 1] = id
        sendBytes[arrIndex] = paBytesAi['ai_color_tracking_X']
    } else {
        sendBytes[arrIndex] = paBytesAi[aiComponents] || 48
    }
}
